import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { BaseUniDriver } from '../base-driver';
import { UniDriver } from '@wix/unidriver-core';
import { jsdomReactUniDriver } from '@wix/unidriver-jsdom-react-legacy';

export type UniDriverFactory<TDriver extends BaseUniDriver> = (
  base: UniDriver,
  body?: UniDriver,
) => TDriver;

function componentFactory(Component: React.ReactElement<any>): UniDriver {
  const wrapperDiv = document.createElement('div');
  const root = createRoot(wrapperDiv!);
  root.render(Component);
  const base = jsdomReactUniDriver(wrapperDiv.childNodes[0] as Element);
  return base;
}

export function createUniDriverFactory<TDriver extends BaseUniDriver>(
  driverFactory: UniDriverFactory<TDriver>,
) {
  const body = jsdomReactUniDriver(document.body);
  return (Component: React.ReactElement<any>) =>
    driverFactory(componentFactory(Component), body);
}
